import FunASR from "../FunASR";
Vue.component("voice_to_text", {
    data() {
        return {
            recordingActive: false, //搜索框录音按钮状态
            touchStartTime: 0,
        }
    },
    mounted() {
    },
    methods: {
        //语音转写
        handleASRToggle(e) {
            e.preventDefault()
            e.stopPropagation()
            const that = this
            if (!this.recordingActive && !(window.location.protocol == 'https:' || window.location.hostname === 'localhost')) {
                this.$message.warning(this.$t('请使用https协议访问！'))
                try {
                    this.recordingActive.stop()
                } catch { }
                this.recordingActive = true
                return
            }
            if (this.recordingActive) {
                //长按事件小于1s
                if (new Date().getTime() - this.touchStartTime < 1000) {
                    this.$message.warning(this.$t('请按住说话！'))
                }
                try {
                    this.recordingActive.stop()
                } catch { }
                this.recordingActive = false
            } else {
                //开始录音
                that.touchStartTime = new Date().getTime()
                that.recordingActive = new FunASR({})
                that.recordingActive.on('ready', function (asr) {
                    asr.start()
                })
                that.recordingActive.on('msg', function (msg) {
                    //过滤掉所有标点符号
                    msg = msg.replace(/[^\u4e00-\u9fa5\w\s]/g, '')
                    that.$emit('msg', msg)
                })
                that.recordingActive.on('audio', function (audio) {
                    console.log('wav', audio)
                })
            }
        },
        handleClick(e) {
            e.preventDefault()
            e.stopPropagation()
        }
    },
    template: `
    <span :class="{voice_to_text: true, active: recordingActive}" @click="handleClick" @mousedown="handleASRToggle" @mouseup="handleASRToggle" @click.stop="{}" :title="$t('按住说话')">
        <iconfont type="iconyuyinshibie"></iconfont>
    </span>
  `,
});